export class createSiteContactMethodResourceModel {
  constructor(
    contactMethodId = null,
    siteContactMethodValue = '',
    isPreferred = true
  ) {
    this.contactMethodId = contactMethodId;
    this.siteContactMethodValue = siteContactMethodValue;
    this.isPreferred = isPreferred;
  }
}
